import { render, staticRenderFns } from "./SnsPostItemHeaderParts.vue?vue&type=template&id=35effdc6&scoped=true"
import script from "./SnsPostItemHeaderParts.vue?vue&type=script&lang=ts"
export * from "./SnsPostItemHeaderParts.vue?vue&type=script&lang=ts"
import style0 from "./SnsPostItemHeaderParts.vue?vue&type=style&index=0&id=35effdc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35effdc6",
  null
  
)

export default component.exports